import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import {
  ButtonsContainer,
  DialogWrapper,
  ModalContainer,
  ModalContent,
  ModalTitle,
} from './styles';
import ActionButton from '../../../components/ActionButton/ActionButton';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';

interface ConfirmActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  confirmButtonText?: string;
  isSuccessMessageToConfirm?: boolean;
}

export const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  confirmButtonText = 'Delete',
  isSuccessMessageToConfirm = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const { t } = useI18n();
  return (
    <DialogWrapper
      open={isOpen}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: 'absolute', top: 16, right: 16 }}
        >
          <CloseIcon />
        </IconButton>
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>{content}</ModalContent>
        <ButtonsContainer>
          {!isSuccessMessageToConfirm && (
            <ActionButton
              variant="cancel"
              buttonText={t(TranslationKeys.confirm_action_modal_cancel_button)}
              onClickAction={onClose}
            />
          )}
          <ActionButton
            variant={isSuccessMessageToConfirm ? 'accept' : 'abort'}
            buttonText={
              isSuccessMessageToConfirm
                ? t(TranslationKeys.survey_form_success_confirm_button)
                : confirmButtonText
            }
            onClickAction={handleConfirm}
          />
        </ButtonsContainer>
      </ModalContainer>
    </DialogWrapper>
  );
};
